import {Button, theme, Tooltip} from 'antd'
import React from 'react'
import {EditOutlined, PlusOutlined, UploadOutlined} from '@ant-design/icons'
import {useIntl} from 'react-intl'

export type PlantControlCanvasButtonsProps = {
  plantId: number
  specimenNumber: number
  openPlantById: (id: number) => void
  digUpPlant: (diggingPlantId?: number, diggingPlantSpecimenNumber?: number) => void
  duplicatePlant: (
    duplicatingPlantId: number,
    specimenNumber: number,
    specimenQuantity: number,
    direction?: string
  ) => void
  isLocked?: boolean
}

export function PlantControlCanvasButtons(props: PlantControlCanvasButtonsProps) {
  const {
    token: {colorPrimary, colorPrimaryBorder, borderRadiusXS},
  } = theme.useToken()
  const intl = useIntl()

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 5, marginLeft: 3}}>
      <Tooltip placement="right" title={intl.formatMessage({id: 'openPlantDescription'})}>
        <Button
          icon={<EditOutlined />}
          onClick={() => {
            props.openPlantById(props.plantId)
          }}
        ></Button>
      </Tooltip>
      {!props.isLocked && (
        <>
          <Tooltip placement="right" title={intl.formatMessage({id: 'digUpAllPlantSpecimens'})}>
            <Button
              icon={<UploadOutlined />}
              onClick={() => {
                props.digUpPlant(props.plantId, props.specimenNumber)
              }}
            ></Button>
          </Tooltip>
          <Tooltip placement="right" title={intl.formatMessage({id: 'duplicatePlant'})}>
            <Button
              icon={<PlusOutlined />}
              onClick={() => {
                props.duplicatePlant(props.plantId, props.specimenNumber, 1, 'right')
              }}
            ></Button>
          </Tooltip>
        </>
      )}
    </div>
  )
}
